import { Type } from 'class-transformer';
import { BaseDto } from './base.dto';
import { Bid } from './bid.dto';
import { Certificate } from './certificate.dto';
import { Contact } from './contact.dto';
import { Contractor } from './contractor.dto';
import { InspectionDto } from './inspections';
import { OrderDirectory } from './order-directory.dto';
import { OrderNote } from './order-note.dto';
import { OrderStatus } from './order-status.dto';
import { Planner } from './planner.dto';
import { SubProject } from './sub-project.dto';

export class Order extends BaseDto {
  isApproved?: boolean;
  assignee?: string;
  approvedBy?: string;
  /** Reviewer username; edits the inspection while the order waits for review. */
  reviewedBy?: string;
  buildingArea?: string;
  units?: string;
  procurementNumber?: string;
  conclusion?: string;
  relatedToOrderId?: number;
  orderCost?: number;
  status?: OrderStatus;
  files?: OrderDirectory;
  sharePoint?: OrderDirectory;
  subProjectId?: number;
  projectId?: number;
  notes?: OrderNote[];
  lastNote?: string;
  icountOrderId?: string;

  @Type(() => SubProject)
  subProject?: SubProject;
  planner?: Planner;
  contacts?: Contact[];
  items?: Bid[];
  certificate?: Certificate;
  contractor?: Contractor;
  version?: number;
  inspection?: InspectionDto;
  inspectionId?: number;
  mainContactId?: number;
  inspectionType?: string;
  totalItems?: number;
  statusUpdatedAt?: Date;
  icountOrderUpdatedAt?: Date;
  inspectionScheduledAt?: Date;
  movedToPlansInspectionAt?: Date;
  isMarked?: boolean;
}
